import {useEffect} from "react"
import Icon from "./icon";

const Button = (props) => {
    const {size, color, label, icon, outline, className, onClick, isReady, children, ...rest} = props
    const btnIcon = !label && !children && icon ? 'btn-icon' : ''

    const handleClick = (ev) => {
        if(typeof onClick === "function"){
            onClick(ev)
        }
    }


    useEffect(() => {

    }, [isReady])


    return (
        <button
            disabled={!isReady}
            onClick={handleClick}
            className={`btn btn-${outline ? 'outline-' : ''}${color} btn-${size} ${btnIcon} ${className ? className : ''}`}
            {...rest}>
            {icon && <Icon name={isReady ? icon : 'disalow'} />} {label}
            {children}
        </button>
    )
}

export default Button